"use client"

import styled from "styled-components"
import { useSocket } from "../../context/SocketContext"

const TaskBarContainer = styled.div`
  position: absolute;
  height: 32px;
  border-radius: 6px;
  cursor: move;
  transition: all 0.2s;
  ${(props) =>
    props.isSelected &&
    `
    box-shadow: 0 0 0 2px white, 0 0 0 4px #2563eb;
  `}
  ${(props) =>
    props.$remoteColor &&
    !props.isSelected &&
    `
    box-shadow: 0 0 0 2px white, 0 0 0 3px ${props.$remoteColor};
  `}
`

const RemoteSelectionLabel = styled.div`
  position: absolute;
  top: -18px;
  right: 8px;
  background-color: ${props => props.$color || '#6b7280'};
  color: white;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 3px;
  white-space: nowrap;
  pointer-events: none;
  z-index: 15;
`

const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`

const ActualProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  z-index: 2;
`

const TaskName = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  padding: 0 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

// 담당자 프로필 사진 스타일
const UserAvatar = styled.div`
  position: absolute;
  top: -20px;
  left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f3f4f6;
  overflow: hidden;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  &:hover::after {
    content: "${(props) => props.userName || "담당자 없음"}";
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #1f2937;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
  }
`

const ResizeHandleLeft = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  cursor: col-resize;
`

const ResizeHandleRight = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  cursor: col-resize;
`

export default function TaskBar({ task, user, left, width, isSelected, onMoveStart, onResizeStart, onResizeEnd }) {
  const { activeSelections } = useSocket();

  // 다른 유저가 이 태스크를 선택하고 있는지 확인
  const remoteSelection = Object.values(activeSelections).find(
    sel => sel.taskId === task.id
  );

  return (
    <TaskBarContainer
      isSelected={isSelected}
      $remoteColor={remoteSelection?.cursorColor}
      style={{
        left: `${left}px`,
        width: `${Math.max(width, 20)}px`,
        backgroundColor: task.color,
      }}
      onMouseDown={onMoveStart}
    >
      {/* 원격 유저 선택 표시 */}
      {remoteSelection && (
        <RemoteSelectionLabel $color={remoteSelection.cursorColor}>
          {remoteSelection.userName}
        </RemoteSelectionLabel>
      )}

      {/* 담당자 프로필 사진 */}
      {user && (
        <UserAvatar userName={user.name}>
          <img src={user.avatar || "/resource/defaultImg.png"} alt={user.name} />
        </UserAvatar>
      )}

      {/* Progress bar */}
      <ActualProgressBar style={{ width: `${task.progress || 0}%` }} />

      {/* Task name */}
      <TaskName>{task.name}</TaskName>

      {/* Resize handles */}
      <ResizeHandleLeft
        onMouseDown={(e) => {
          e.stopPropagation()
          onResizeStart(e)
        }}
      />
      <ResizeHandleRight
        onMouseDown={(e) => {
          e.stopPropagation()
          onResizeEnd(e)
        }}
      />
    </TaskBarContainer>
  )
}

